import { render, staticRenderFns } from "./Postprojectreport.vue?vue&type=template&id=38659833&scoped=true&"
import script from "./Postprojectreport.vue?vue&type=script&lang=js&"
export * from "./Postprojectreport.vue?vue&type=script&lang=js&"
import style0 from "./Postprojectreport.vue?vue&type=style&index=0&id=38659833&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38659833",
  null
  
)

export default component.exports